import React from 'react';
import { Card } from 'react-bootstrap';
import './HomeCard.css';

interface HomeCardProps {
  title: string;
  text: string;
  icon: string;
}

const HomeCard: React.FC<HomeCardProps> = ({ title, text, icon }) => {
  return (
    <Card className="home-card h-100" >
      <Card.Body className="d-flex flex-column" style={{ width: '100%' }}>
        <div className="icon-circle mb-3">
          <img src={icon} alt={title} className="card-icon" />
        </div>
        <Card.Title className="card-title">{title}</Card.Title>
        <Card.Text className="card-text">{text}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default HomeCard;
export {}